module.exports = __webpack_public_path__ + "static/deported-final-6b89a614a8ee498cb772208e386232e9.jpg";